import React from 'react';
import {Badge} from "@shopify/polaris";

import {ConsignmentStatus} from "../services/ConsignmentService";

type ConsignmentStatusBadgeProps = {
    status: ConsignmentStatus
}

const ConsignmentStatusBadge = ({status} : ConsignmentStatusBadgeProps) => {

    if (status === ConsignmentStatus.UNASSIGNED) {
        return (
            <Badge status="new">Unassigned</Badge>
        )
    }

    if (status === ConsignmentStatus.ASSIGNED) {
        return (
            <Badge status="info" progress="incomplete">Assigned</Badge>
        )
    }

    if (status === ConsignmentStatus.STARTED) {
        return (
            <Badge status="info" progress="partiallyComplete">Started</Badge>
        )
    }

    if (status === ConsignmentStatus.COMPLETED) {
        return (
            <Badge status="success" progress="complete">Completed</Badge>
        )
    }

    if (status === ConsignmentStatus.CANCELLED) {
        return (
            <Badge status="warning">Cancelled</Badge>
        )
    }

    return (
        <Badge status="info">{status}</Badge>
    )
};

export default ConsignmentStatusBadge;